import styled from "@emotion/styled";
import React from "react";
import CheckGreenIcon from "src/assets/images/check-green.png";
import { OfferCoverageEntryType } from "src/common/api/apollo/additional";
import { Flex, Text } from 'src/components';
import { colors } from "src/theme";

const CoverageStyle = styled.div({
  padding: '8px',
  backgroundColor: "#F2F2F270",
  borderRadius: '4px',
  display: 'flex',
  flexDirection: 'column',
  paddingLeft: '12px',
  minWidth: 0,
  lineHeight: '20px',
  gap: 4,
});

const CoverageText = styled(Text)({
  minWidth: 0,
  overflowWrap: 'break-word',
  wordBreak: 'break-word',
});

const CoverageDescription = styled(Text)({
  minWidth: 0,
  overflowWrap: 'break-word',
  wordBreak: 'break-word',
});

const DescriptionContainer = styled(Flex)({
  paddingLeft: '24px',
  '& ul': {
    margin: 0,
    padding: 0,
    paddingLeft: '24px',
  },
  '& li': {
    margin: 0,
    padding: 0,
  },
  '& li::marker': {
    fontSize: '0.75em',
  },
});

const DETAILS_EASE = 'cubic-bezier(0.4, 0, 0.2, 1)';

const DetailsCollapse = styled.div<{ open: boolean }>(({ open }) => ({
  display: 'grid',
  gridTemplateRows: open ? '1fr' : '0fr',
  transition: `grid-template-rows 0.38s ${DETAILS_EASE}`,
}));

const DetailsInner = styled.div<{ open: boolean }>(({ open }) => ({
  minHeight: 0,
  overflow: 'hidden',
  opacity: open ? 1 : 0,
  transform: open ? 'translateY(0)' : 'translateY(-6px)',
  transition: `opacity 0.28s ${DETAILS_EASE}, transform 0.32s ${DETAILS_EASE}`,
}));

interface CoveragesAdditionalCardProps {
  coverages?: Array<OfferCoverageEntryType>;
  fixedCoverages?: Array<OfferCoverageEntryType>
  className?: string;
  isDetailsOpen?: boolean;
}

const AnimatedCoverageDescription = ({
  html,
  open,
}: {
  html: string;
  open: boolean;
}) => (
  <DetailsCollapse open={open}>
    <DetailsInner open={open}>
      <DescriptionContainer vertical>
        <CoverageDescription type="tiny" dangerouslySetInnerHTML={{ __html: html }} color={colors.text2} />
      </DescriptionContainer>
    </DetailsInner>
  </DetailsCollapse>
);

export const CoveragesAdditionalCard = ({ coverages, fixedCoverages, className, isDetailsOpen }: CoveragesAdditionalCardProps) => {
  const open = Boolean(isDetailsOpen);

  return (
    <Flex vertical gap={4} className={className}>
      {fixedCoverages && fixedCoverages.map((coverage, index) => (
        <CoverageStyle key={index}>
          <Flex gap={16} align='center'>
            <img src={CheckGreenIcon} alt="check-green" height={6} width={8} style={{ flexShrink: 0 }} />
            <CoverageText bold={isDetailsOpen} type="small" color={colors.text2}>{coverage.label}</CoverageText>
          </Flex>
          {coverage.description ? (
            <AnimatedCoverageDescription html={coverage.description} open={open} />
          ) : null}
        </CoverageStyle>
      ))}
      {coverages && coverages.map((coverage, index) => (
        <CoverageStyle key={index}>
          <Flex gap={16} align='center'>
            <img src={CheckGreenIcon} alt="check-green" height={6} width={8} style={{ flexShrink: 0 }} />
            <CoverageText bold={isDetailsOpen} type="small" color={colors.text2}>{coverage.label}</CoverageText>
          </Flex>
          {coverage.description ? (
            <AnimatedCoverageDescription html={coverage.description} open={open} />
          ) : null}
        </CoverageStyle>
      ))}
    </Flex>
  );
};
